import React,{ useEffect,useState } from 'react';
import ReactDOM from 'react-dom';
import parse from 'html-react-parser';
import "./SingleLevel.css";
const SingleLevel = ({ item }) => {

   const [camData,setCamData] = useState("");
   var animTime = 1;
   var cameraType = null;   
   const handlecameraClick = (divname,itemtype,sequenceName) => {  
   window.navigationStatus = false;
      if(window.playVideo) window.pauseVideo();
      if (document.getElementById("rest_button") != undefined) document.getElementById("rest_button").style.display = "none";
   if (document.getElementById("footerControl") != undefined) document.getElementById("footerControl").style.display = 'block';
   window.hideAllHotspot();
   window.hideCallouts();
      var menuTitle =  window.removeTags(item.title);    
      // console.log(menuTitle,  window.configProduct.name);
      // window.RT_RecordEvent(menuTitle,  window.configProduct.name); 
      clearTimeout(window.myTimeout);
      clearTimeout(window.clearsettimeout);
      document.body.classList.remove('hotspotShow');
      if (document.getElementById("exterior_title") != undefined) document.getElementById("exterior_title").style.display = "none";
      if (document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "none";

      window.scene._nav.SetRotationCenter([0,0,0]);
      
      window.hideAllPopup();
      setTimeout(() => {
         window.menuHeightCalaulate()         
      }, 200);
      let currentActivePopup = document.querySelector('.content.currentActivePopup');
      let currentActiveHotspot = document.querySelector('.hotspots.currentActiveHotspot');
      if(currentActiveHotspot != null) currentActiveHotspot.classList.remove('currentActiveHotspot');
      if(currentActivePopup != null) currentActivePopup.classList.remove('currentActivePopup');
      let currentActivesinglePopup  = document.querySelector('.singlePopup.active');
      if(currentActivesinglePopup != null) currentActivesinglePopup.classList.remove('active');

      let hotspotsActive = [...document.querySelectorAll(".hotspots")];
      hotspotsActive.forEach(ele => {
            ele.style.display = "none";
      });
      window.currentPosition = '';


      if (window.mob) {
         window.scene._bDoF = false;
      } else {
         window.scene._bDoF = false;
      }
     
      if (itemtype !== 'Skins') {
         if (window.functionClick) return false;
         window.functionClick = true;   
         if (!divname) {
            return false;
         }
         if (window.menuClick == false) {
            return false;
         }
         var isActive = document.getElementById(divname)
         if (isActive.classList.contains('active')) {
            if (window.mob || (window.isipad && window.innerHeight > window.innerWidth)) {
               document.getElementById(divname).classList.remove('active');
            }
         }
         else {
            const collection = document.getElementsByClassName("menu");
            for (let i = 0; i < collection.length; i++) {
               collection[i].classList.remove('active');
            }
            document.getElementById(divname).classList.add('active');
         }

         if (window.mob || window.isipad || window.innerWidth < 818 || window.innerHeight < 818) {
            const arrow = document.getElementsByClassName("content1");
            for (let i = 0; i < arrow.length; i++) {
               if (arrow[i].getAttribute('id') !== "content1-" + divname + "") {
                  arrow[i].style.maxHeight = null
               }
            }
            var content = document.getElementById("content1-" + divname + "");
            if (content.style.maxHeight) {
               content.style.maxHeight = null;
            } else {
               content.style.maxHeight = "100%";
            }
         }

         //console.log((divname)
         window.animCounterCollaboration = 0;
         window.animCounterSustainability = 0;
         window.animCounterFrontCollaboration = 0;

         clearInterval(window.screenAnimIntervalCollaboration);
         clearInterval(window.screenAnimIntervalFrontCollaboration);
         clearInterval(window.screenAnimIntervalSustainability);
         if (divname === "Render_Cam_FL_F05") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_FL_F05) }
            else { window.Render_Cam_FL_F05() }
            window.selectedMenu.active = 'Render_Cam_FL_F05';
         }

         else if (divname === "Render_Cam_Copilot_F01") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Copilot_F01) }
            else { window.Render_Cam_Copilot_F01() }
            window.selectedMenu.active = 'Render_Cam_Copilot_F01';
         }

         else if (divname === "Render_Cam_Sustainability_F05") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Sustainability_F05) }
            else { window.Render_Cam_Sustainability_F05() }
            window.selectedMenu.active = 'Render_Cam_Sustainability_F05';
            window.Render_Cam_Sustainability_F05() 
         }

         else if (divname === "Reset_View_F14") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Reset_View_F14) }
            else { window.Reset_View_F14() }
            window.selectedMenu.active = 'Reset_View_F14';
         }
         else if (divname === "Render_Cam_Right_Port_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Right_Port_F50) }
            else { window.Render_Cam_Right_Port_F50() }
            window.selectedMenu.active = 'Render_Cam_Right_Port_F50';
         }
         else if (divname === "Render_Cam_Security") {
            cameraType = 'interior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Security) }
            else { window.Render_Cam_Security() }
            window.selectedMenu.active = 'Render_Cam_Security';
         }
         else if (divname === "Render_Cam_Collaboration_F05") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Collaboration_F05) }
            else { window.Render_Cam_Collaboration_F05() }
            window.selectedMenu.active = 'Render_Cam_Collaboration_F05';
            window.Render_Cam_Collaboration_F05() 
         }
         else if (divname === "Render_Cam_AI_F01") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_AI_F01) }
            else { window.Render_Cam_AI_F01() }
            window.selectedMenu.active = 'Render_Cam_AI_F01';
         }
         else if (divname === "Render_Cam_AI_Turbo_Engine_F01") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_AI_Turbo_Engine_F01) }
            else { window.Render_Cam_AI_Turbo_Engine_F01() }
            window.selectedMenu.active = 'Render_Cam_AI_Turbo_Engine_F01';
         }
         else if (divname === "Render_Cam_Wireless_Charging_F05") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Wireless_Charging_F05) }
            else { window.Render_Cam_Wireless_Charging_F05() }
            window.selectedMenu.active = 'Render_Cam_Wireless_Charging_F05';
         }
         else if (divname === "Render_Cam_Secure_E_shutter_F05") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Secure_E_shutter_F05) }
            else { window.Render_Cam_Secure_E_shutter_F05() }
            window.selectedMenu.active = 'Render_Cam_Secure_E_shutter_F05';
         }
         else if (divname === "Render_Cam_Chip_F15") {
            cameraType = 'interior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Chip_F15) }
            else { window.Render_Cam_Chip_F15() }
            window.selectedMenu.active = 'Render_Cam_Chip_F15';
         }
         else if (divname === "Render_Cam_Tharmal") {
            cameraType = 'interior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Tharmal) }
            else { window.Render_Cam_Tharmal() }
            window.selectedMenu.active = 'Render_Cam_Tharmal';
         }
       
         sequenceName && window.scene.applySequence(window[sequenceName], function (){});   
      } else {
         const collection = document.getElementsByClassName("skin_menu");
         document.getElementById("Skins").classList.remove('MuiCollapse-hidden');
         document.getElementById("Skins").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
         document.getElementById("Skins").previousSibling.classList.add('menuActive');
         for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove('active');
         }
         window.changeSkin(divname);
      }
      window.scene._nav._fRotMinLimitConst = 0.3
      window.updateNavigation(divname);
      window.resetpop();
      setTimeout(function(){
         window.updateZoomSliderUIOnly(window.sliderEl3, window.scene._nav.getZoomFactor());
      },2000);
      window.calloutPositionReset();

   }
   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname, onComplete, onSample) => {
      // alert("111")
      let zoomResize = window.setZoomReset();
      var opt = undefined;
      if (!(window.mob || window.isipadPortrait)) {
         var gp = camData[gotoposname];
      } else {
         // var gp = camData[gotoposname];
         var gp = camData[gotoposname + '_Mob'];
         // if (gotoposname == 'Reset_View_F14_EVO') { 
         //    zoomResize = -80;
         // }
         // else if (gotoposname == 'Render_Cam_F50_Camera_Zoom') {
         //    zoomResize = -15;
         // }
         // else {
         //           zoomResize = -35;
         // }
      }
      if (gp.fovy && window.scene.fovy !== gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      gp.time = animTime;
      // console.log(zoomResize)
      window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + zoomResize, 2000, onComplete, slowinout2, opt);
   }
   function slowinout2(x) {
      var a = 4.0;
      var x2 = 1.0 - x;
      var px = Math.pow(x, a);
      var px2 = Math.pow(x2, a);
      return px / (px + px2);
   }
   
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x, a);
      var px2 = Math.pow(x2, a);
   
      return px / (px + px2);
   }
   const GetData = async () => {

      await fetch('model_gl/config.json'
         ,{
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      ).then((response) => response.json())
         .then((myJson) => {
            setCamData(myJson.positions);
         })         
   }
   useEffect(() => {
      GetData();
   },[]);

   return (
      item.type !== 'Skins' ? <div className={`menu`} id={item.id}>
         <div className='MuiButtonBase-root MuiListItem-root collapsible MuiListItem-gutters MuiListItem-button' onClick={() => { handlecameraClick(item.id,item.type,item.sequenceName) }}>
            <div className='accordia_icon'>
               <img className='arrow' src='img/spacer.png' id={`accordianIcon_${item.id}`} />
            </div>
            <div className="MuiListItemText-root">   <span className="MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock" id={`${item.id}`}>
      {parse(item.title || '')}
   </span>
   </div>
         </div>
         {ReactDOM.createPortal(
         <>
            {item.content && item.content.map((child, key) => (
                  <div key={key} className='calloutbox font28 calloutbox_white' data-id={child.dataId} id={child.dataId+'_popupJSON'}>
                     <h3>{ parse(child.heading || '') }</h3>
                     {child.subheading !== undefined && 
                     <h4>{ parse(child.subheading || '') }</h4>
                     }
                     <div className='content'>
                        <div>
                           <ul className='listItem1'>
                                 <li>{ parse(child.text || '') }</li>
                                 {child.content2  && <ul>
                                    {child.content2 && child.content2.map((content2, key) => {
                                       return (
                                          <li  key={key} className='submenutext'>{content2}</li>
                                       )
                                    })
                                    }
                                 </ul> }
                              </ul>
                          </div>
                        {child.text1 !== undefined &&
                           <ol className='listItem1 leftText'>
                              <li>{ parse(child.text1) }</li>
                              <li>{ parse(child.text2) }</li>
                           </ol>
                        } 
                        {child.text2 !== undefined &&
                        <ol className='listItem2 backText'>
                           <li>{ parse(child.text3) }</li>
                           <li>{ parse(child.text4) }</li>
                           <li>{ parse(child.text5) }</li>
                           <li>{ parse(child.text6) }</li>
                           <li>{ parse(child.text7) }</li>
                           <li>{ parse(child.text8) }</li>
                           <li>{ parse(child.text9) }</li>
                           <li>{parse(child.text10)}</li>
                        </ol>
                        } 
                        {child.text3 !== undefined &&
                           <ol className='listItem3 rigthText'>
                              <li>{ parse(child.text11) }</li>
                              <li>{ parse(child.text12) }</li>
                           </ol>
                        }
                        {child.vproicon !== undefined &&
                           <img className={`vpro_logo`} src={child.vproicon} />
                        }
                         {child.intelicon !== undefined &&
                           <img className={`intel_logo`} src={child.intelicon} />
                        }
                         {child.intelcoreicon !== undefined &&
                           <img className={`intel_core_logo`} src={child.intelcoreicon} />
                        }
                         {child.intelcoreiconwith7 !== undefined &&
                           <img className={`intel_core_logo`} src={child.intelcoreiconwith7} />
                        }
                        {child.thinkshield !== undefined &&
                           <img className={`thinkshieldLogo`} src={child.thinkshield} />
                        }
                        {(child.bottomBtn1 != undefined && child.bottomBtn2 && child.bottomBtn2) && <div id="penButtondiv">
                           <div id={child.bottomBtn1.id} className={child.bottomBtn1.classList}>{child.bottomBtn1.text}</div>
                           <div id={child.bottomBtn2.id} className={child.bottomBtn2.classList}>{child.bottomBtn2.text} </div>
                           <div id={child.bottomBtn3.id} className={child.bottomBtn3.classList}>{child.bottomBtn3.text} </div>
                        </div>
                        }
                         {(child.videoBtn != undefined && child.soundBtn) && <div id="soundvideoDiv">
                           <div id={child.videoBtn.id} className={child.videoBtn.classList}>{child.videoBtn.text} </div>
                           <div id={child.soundBtn.id} className={child.soundBtn.classList}>{child.soundBtn.text} </div>
                        </div>
                        }
                     </div>
                  </div>
               ))
               }
         </>, document.getElementById('calloutContainer')
         )}
         <div className="content1" id={`content1-${item.id}`}>
            <div id={`hotspot_${item.id}`}>
               {item.content && item.content.map((child,key) => (
                  <div key={key} className='popuptogglebtn' data-id={child.dataId}>
                     <p>{ parse(child.heading || '') }</p>
                     {child.subheading !== undefined &&
                        <p className='subheading'>{parse(child.subheading)}</p>
                     }
                     <h5 className='listItem1'>
                        { parse(child.text || '') }
                        <ul>
                           {child.content2 && child.content2.map((content2, key) => {
                              return (
                                 <li key={key} className='submenutext'>{content2}</li>
                              )
                           })
                           }
                        </ul>
                     </h5>
                     { child.text1 !== undefined && 
                        <ol className='listItem2 leftText'>
                           <li>{ parse(child.text1) }</li>
                           <li>{ parse(child.text2) }</li>
                        </ol>
                     }  
                     { child.text2 !== undefined && 
                         <ol className='listItem3 backText'>
                           <li>{ parse(child.text3) }</li>
                           <li>{ parse(child.text4) }</li>
                           <li>{ parse(child.text5) }</li>
                           <li>{ parse(child.text6) }</li>
                           <li>{ parse(child.text7) }</li>
                           <li>{ parse(child.text8) }</li>
                           <li>{ parse(child.text9) }</li>
                           <li>{ parse(child.text10) }</li>
                        </ol>
                     }  
                     { child.text3 !== undefined && 
                        <ol className='listItem4 rigthText'>
                           <li>{ parse(child.text11) }</li>
                           <li>{ parse(child.text12) }</li>
                        </ol>
                     } 
                     {child.vproicon !== undefined && 
                     <img className={`vpro_logo_mob`} src={child.vproicon} />
                     }      
                     {child.intelicon !== undefined &&
                       <img className={`intel_logo_mob`} src={child.intelicon} />
                    }
                    {child.intelcoreicon !== undefined &&
                        <img className={`intel_core_logo_mob`} src={child.intelcoreicon} />
                     }     
                    {child.intelcoreiconwith7 !== undefined &&
                        <img className={`intel_core_logo_mob`} src={child.intelcoreiconwith7} />
                     }      
                    {child.thinkshield !== undefined &&
                        <img className={`thinkshieldLogo_Mob`} src={child.thinkshield} />
                     }
                    {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'Render_Cam_Collaboration_F05' ? <div id="penButtondiv">
                        <div id="left" className="active">Left</div>
                        <div id="back" className="">Back</div>
                        <div id="right" className="">Right</div>
                     </div>
                        : ''}  
                    {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'immersive_sound_and_video' ? <div id="soundvideoDiv">
                        <div id="video_port" className="active">Video </div>
                        <div id="sound_port" className="">Sound </div>
                     </div>
                        : ''}  
                  </div>
               ))
               }
            </div>
         </div>
      </div>
         : <div className={`skin_menu`} id={item.id}>
            <div className='skin_icon' onClick={() => { handlecameraClick(item.id,item.type,item.sequenceName) }} title={item.name}>
               <img src={item.icon} />
            </div>
         </div>
   );
};
export default SingleLevel